import React, { useState, useEffect } from "react";
import Image from "../../Elements/Image/Image.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import getAsyncImage from "../../../utils/getAsyncImage.js";

const arr = [
  {
    id: 1,
    url: `subscribers/screen1`,
  },
  {
    id: 2,
    url: `subscribers/screen2`,
  },
  {
    id: 3,
    url: `subscribers/screen3`,
  },
  {
    id: 4,
    url: `subscribers/screen4`,
  },
];

const CarouselComponent = () => {
  const { getTextByKey } = useContent();
  const [state, setState] = useState({
    index: arr.length - 1,
    selected: arr[0],
  });

  const [show, setShow] = useState(true);

  const nextImage = () => {
    setShow(false);
    setTimeout(() => {
      setShow(true);
    }, 450);
  };

  useEffect(() => {
    show &&
      setState((prevState) => {
        const newIndex =
          prevState.index < arr.length - 1 ? prevState.index + 1 : 0;
        return {
          index: newIndex,
          selected: arr[newIndex],
        };
      });
  }, [show]);

  useEffect(() => {
    setInterval(() => {
      nextImage();
    }, 5000);
  }, []);

  const [image, setImage] = useState(null);
  useEffect(() => {
    getAsyncImage(`images/${state.selected.url}.png`, setImage);
  }, [state.selected.url]);

  return (
    <div className="images-carousel">
      <div
        className="background-image-container"
        style={{ backgroundImage: `url(${image})` }}
      >
        <Image
          name={state.selected.url}
          ext="png"
          alt={
            getTextByKey("subscribers-image-alt-logo-examples") +
            "-" +
            state.selected.id
          }
        />
      </div>
    </div>
  );
};

export default CarouselComponent;
